import { render, staticRenderFns } from "./UserName.vue?vue&type=template&id=5be21d76"
import script from "./UserName.vue?vue&type=script&lang=js"
export * from "./UserName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports